export const LOADER_STATUS = 'boilerplate/report/LOADER_STATUS';
export const SET_PAGE_COUNT = 'boilerplate/report/SET_PAGE_COUNT';
export const SET_PAGE_DATA = 'boilerplate/report/SET_PAGE_DATA';
export const SET_CURRENT_PAGE = 'boilerplate/report/SET_CURRENT_PAGE';